import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';

// @ts-expect-error untyped dependency
import CompareFormsAllowed from 'FormsUI/components/formActions/CompareFormsAllowed';
import CompareFormsDisallowed from 'FormsUI/components/formActions/CompareFormsDisallowed';
import QuarantineAction from 'FormsUI/components/dashboard/QuarantineAction';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DashboardActions = ({
  isPqlDisabled = false,
  buttonSize = 'small'
}) => /*#__PURE__*/_jsx("div", {
  "data-test-id": "dashboard-actions",
  children: /*#__PURE__*/_jsx(UIDropdown, {
    animateOnToggle: true,
    buttonUse: 'secondary',
    buttonSize: buttonSize,
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: 'actions'
    }),
    children: /*#__PURE__*/_jsxs(UIList, {
      children: [isPqlDisabled ? /*#__PURE__*/_jsx(CompareFormsDisallowed, {}) : /*#__PURE__*/_jsx(CompareFormsAllowed, {}), /*#__PURE__*/_jsx(QuarantineAction, {})]
    })
  })
});
export default DashboardActions;